// Pure helpers for the visits day view: where a visit sits and how overlaps share width.
import { parseBackendDateMs } from '../../agent/time';

export const MIN_MS = 60 * 1000;
export const DEFAULT_VISIT_MIN = 45;
export const SNAP_MIN = 15;

// Appointment window: scheduledStart/End when set, else createdAt + a default length.
export function visitWindow(conversation) {
  const start =
    parseBackendDateMs(conversation.scheduledStart) ??
    parseBackendDateMs(conversation.createdAt);
  if (!Number.isFinite(start)) return null;
  let end = parseBackendDateMs(conversation.scheduledEnd);
  if (!Number.isFinite(end) || end <= start) {
    end = start + DEFAULT_VISIT_MIN * MIN_MS;
  }
  return { start, end };
}

export function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function isSameDay(a, b) {
  return startOfDay(a).getTime() === startOfDay(b).getTime();
}

// Visits on `day`, as { conversation, s, e } in minutes from that day's midnight.
export function visitsOnDay(conversations, day) {
  const dayMs = startOfDay(day).getTime();
  return (conversations || [])
    .map((conversation) => {
      const win = visitWindow(conversation);
      if (!win || !isSameDay(win.start, dayMs)) return null;
      return {
        conversation,
        s: Math.round((win.start - dayMs) / MIN_MS),
        e: Math.round((win.end - dayMs) / MIN_MS),
      };
    })
    .filter(Boolean);
}

export function clockLabel(min) {
  const h = Math.floor(min / 60);
  const ap = h >= 12 && h < 24 ? 'PM' : 'AM';
  return `${h % 12 || 12}:${String(min % 60).padStart(2, '0')} ${ap}`;
}

// The patient's name when the visit has one, else what the visit is called.
export const visitTitle = (c) =>
  c.patientName && c.patientName !== 'Unknown'
    ? c.patientName
    : c.conversationName || '';

// Appointment type from the sync, else a non-date tail of the name ("Jane - Eval").
export function visitTypeOf(c) {
  const direct = c.visitType || c.appointmentType || c.noteType;
  if (direct) return String(direct).trim();
  const name = String(c.conversationName || '');
  const i = name.lastIndexOf(' - ');
  if (i < 0) return null;
  const tail = name.slice(i + 3).trim();
  if (
    !tail ||
    /\d{1,2}\/\d{1,2}\/\d{2,4}|\d{4}-\d{2}-\d{2}/.test(tail) ||
    tail.length > 40
  )
    return null;
  return tail;
}
